// extracted by mini-css-extract-plugin
export default {"dataTableFormat":"styles_dataTableFormat__3dz-T","formSpace":"styles_formSpace__Braxe","actionButton":"styles_actionButton__gNS1T","actionIcon":"styles_actionIcon__6KHbb"};